module.exports = __webpack_public_path__ + "static/img/jidan.e4b9c2c4.png";